import React from 'react';
import { MDBFooter} from 'mdbreact';

function PageNotFound(){
    return(
       
<h1>Page Not Found</h1>
    )}

export default PageNotFound;